import axios from "axios";
import { api } from "./api_route";

export const allOrganiationReports = async (values) => {
  try {
    const result = await axios.get(`${api}/organizationRepors/`, {
      params: values,
    });

    return result;
  } catch (error) {
    return [];
  }
};

export const allOrganiationSingleReports = async (values) => {
  try {
    const result = await axios.post(`${api}/organizationRepors/reports`, {
       values,
    });

    return result;
  } catch (error) {
    return [];
  }
};

export const createOrganiationReports = async (values) => {
  try {
    const result = await axios.post(`${api}/organizationRepors/create`, values);

    return result;
  } catch (error) {
    return [];
  }
};

export const updateOrganiationReports = async (values) => {
  try {
    const result = await axios.post(`${api}/organizationRepors/update`, values);

    return result;
  } catch (error) {
    return [];
  }
};

export const emailOrgReport = async (values) => {
  try {
    const result = await axios.post(`${api}/organizationRepors/emailOrgReport`, values);

    return result;
  } catch (error) {
    return [];
  }
}


export const deleteOrganiationReports = async (values) => {
  try {

    const result = await axios.delete(`${api}/organizationRepors/delete/${values.id}`);

    return result;
  } catch (error) {
    return [];
  }
};

